import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, message, Radio } from 'antd'

import { req_add_ars_reservationCase, req_list_ars_canSelectTimeDivision, req_single_gam_graduateFresh } from '../../api'

class ReservationSelfModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        qualify: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        options: [],
        awardee: {},
        item: {
            ReservationIProjectNid: this.props.qualify.ReservationIProjectNid,
            ClaimerCode: this.props.qualify.EligibleCode,
            ClaimerName: this.props.qualify.EligibleName,
            ClaimerPhone: '',
            Division: this.props.qualify.Division,
            QualifyKeyId: this.props.qualify.KeyId,
            ReservationType: 'ONSITE',
            ReservationTimeTag: '0000000000000000',
            ReservationLocation: '',
        }
    }

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_single_graduateFresh()
        this.init()
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_single_graduateFresh = async () => {
        const { token } = this.props.user
        const { EligibleCode } = this.props.qualify
        this.setState({ loading: true })
        const result = await req_single_gam_graduateFresh(EligibleCode, token)
        this.setState({ loading: false })
        const awardee = result
        if (result) {
            const { item } = this.state
            this.setState({ awardee })
            item.ClaimerPhone = result.MobilePrincipal
            this.setState({ item })
        }
        //console.log(awardee)
    }

    api_add_applycase = async (applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_add_ars_reservationCase(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            message.success('預約成功，請於約定當日前來，謝謝')
        } else {
            message.error(result.message)
        }
    }

    api_list_canSelectTime = async () => {
        const token = this.props.user.token
        const { Division } = this.props.qualify
        this.setState({ loading: true })
        const result = await req_list_ars_canSelectTimeDivision(Division, token)
        this.setState({ loading: false })
        //console.log(result)
        const options = [];
        if (result.data) {
            result.data.forEach(function (item) {
                options.push({ 'label': item.ReservationTimeTag.substring(4, 6) + '/' + item.ReservationTimeTag.substring(6, 8) + '(' + item.ReservationWeek + ') ' + item.ReservationTimeTag.substring(8, 12) + '-' + item.ReservationTimeTag.substring(12, 16), 'value': item.ReservationTimeTag })
            });
            this.options = options;
            this.setState({ options })
        } else {
            this.setState({ options: [] })
        }
        //console.log(this.options)
    }

    init = () => {
        this.api_list_canSelectTime()
    }

    /////////////////////////////////////////////////////////// 


    handleChange(event) {
        const { item } = this.state
        //console.log(event)

        if (event.target.type) {
            if (event.target.type === "radio") {
                if (event.target.value !== null) {
                    item['ReservationTimeTag'] = event.target.value.trim()
                    this.setState({ item })
                    //console.log(item)
                }
            }
        }else{
            Object.keys(item).forEach(propertyName => {
                if (event.target.id === propertyName && event.target.value !== null) {
                    item[propertyName] = event.target.value.trim()
                }
            });
            this.setState({ item })
        }

    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.state.item
        const errors = []

        if (row.ReservationTimeTag.trim() === '0000000000000000') {
            errors.push('日期未選擇')
        }
        if (!row.ClaimerPhone.trim()) {
            errors.push('連絡電話未填')
        }

        if (errors.length === 0) {
            this.api_add_applycase(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    /////////////////////////////
    render() {
        const { options,  } = this.state
        const { Division } = this.props.qualify
        const { MobilePrincipal } = this.state.awardee
        const info = (Division === '日間部') ? '可預約日期皆已滿額，請明日再預約如有疑問請洽學務處生活輔導組[侯雅庭小姐-(06)2535644#222]' : '可預約日期皆已滿額，請明日再預約如有疑問請洽進修部[羅英碩先生-(06)2535647]'
        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                {
                                    (options.length === 0 ? info : <Radio.Group
                                        options={options}
                                        onChange={this.handleChange}
                                        optionType="button"
                                        buttonStyle="solid"
                                    />)
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                {
                                    (options.length === 0 ? '' :
                                        <>
                                            <label><span className="text-danger">*</span>連絡電話</label>
                                            <input type="text" className="form-control text-primary" name="ClaimerPhone" id="ClaimerPhone" placeholder="請輸入連絡電話" defaultValue={MobilePrincipal} onChange={this.handleChange} />
                                        </>)
                                }
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        {
                            (options.length === 0 ? '' : <input type="submit" value="檢核預約資料" className="btn btn-primary btn-sm" />)
                        }

                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ReservationSelfModal)